<template>
    <div
            class="switch"
            :class="[{ 'on': selected === true, 'off': selected === false, 'invert': invert}, variant]"
            @mousedown="mouseDownHandler"
            @mousemove="mouseMoveHandler"
            @mouseup="mouseUpHandler"
            @mouseleave="mouseUpHandler"
            @touchstart="mouseDownHandler"
            @touchmove="mouseMoveHandler"
            @touchend="mouseUpHandler"
            @touchcancel="mouseUpHandler"
            @touchleave="mouseUpHandler"
            ref="switch"
    >
        <input type="radio" id="idNotApplicable" name="" class="jsNotApplicable" value="">
        <label for="idNotApplicable" class="not-applicable" @click="onChange(false)">
            <span class="ml-1" v-if="invert">N</span>
        </label>
        <input type="radio" id="idNotChecked" name="" class="jsNotChecked" value="" checked="checked">
        <label for="idNotChecked" class="not-checked" @click="onChange(null)"></label>
        <input type="radio" id="idApplicable" name="" class="jsApplicable" value="">
        <label for="idApplicable" class="applicable" @click="onChange(true)">
            <span class="ml-2" v-if="invert">O</span>
        </label>
        <div
                class="switch__btn"
                :class="[{
                    'middle': selected === null,
                    'on': selected === true,
                    'off': selected === false,
                    'moving': move.progress
                }, variant]"
                :style="[move.progress ? { 'left': marginLeft + 'px' } : null]"
                ref="switchBtn"
        >
            <div class="switch__btn__bar"></div>
            <div class="switch__btn__bar"></div>
            <div class="switch__btn__bar"></div>
        </div>
    </div>
</template>
<script>
    const TREND = {
        NONE: 0,
        INCREASE: 1,
        DECREASE: 2
    }

    /**
     * @see {@link https://codepen.io/alex6632/pen/qqLmbL}
     */
    export default {
        name: 'SwitchExtended',
        props: {
            value: [Boolean, null],
            invert: {
                type: Boolean,
                default: false
            },
            variant: {
                default: 'primary',
                type: String
            },
            isNullable: {
                default: true,
                type: Boolean
            }
        },
        mounted() {
            this.selected = this.value
            this.$nextTick(() => {
                this.isLoaded = true
            })
        },
        data: () => ({
            selected: null,
            isLoaded: false,
            moving: false,
            marginLeft: 0,
            move: {
                originalX: null,
                pending: false,
                progress: false,
                processed: false,
                trend: TREND.NONE
            }
        }),
        watch: {
            selected(value) {
                if(!this.isNullable && this.selected === null) this.selected = false
                if (this.isLoaded) this.$emit('input', value)
            }
        },
        methods: {
            onChange(value) {
                const processed = this.move.processed
                this.$set(this.move, 'processed', false)
                if (processed) return
                this.selected = value
            },
            mouseDownHandler(e) {
                if (this.move.pending || this.move.progress) return
                this.marginLeft = this.$refs.switchBtn.offsetLeft
                this.$set(this.move, 'pending', true)
            },
            mouseMoveHandler(e) {
                if (!this.move.pending && !this.move.progress) return
                this.$set(this.move, 'pending', false)
                this.$set(this.move, 'progress', true)
                const elementX = (e.pageX - this.getXYPos(this.$refs.switch).x) - (this.$refs.switchBtn.clientWidth / 2)
                const correctX = Math.round(Math.max(0, Math.min(elementX, this.$refs.switch.clientWidth - this.$refs.switchBtn.clientWidth)))
                if (this.move.originalX === null)
                    this.$set(this.move, 'originalX', correctX)
                const trend = (correctX === this.move.originalX) ? TREND.NONE : ((correctX > this.move.originalX) ? TREND.INCREASE : TREND.DECREASE)
                this.$set(this.move, 'trend', trend)
                this.marginLeft = correctX
            },
            mouseUpHandler(e) {
                if (!this.move.pending && !this.move.progress) return
                this.$set(this.move, 'pending', false)
                this.$set(this.move, 'progress', false)
                this.$set(this.move, 'processed', this.move.trend !== TREND.NONE)
                this.selected = this.move.trend === TREND.INCREASE ? true : false
                this.marginLeft = 0
                this.$set(this.move, 'trend', TREND.NONE)
                this.$set(this.move, 'originalX', null)
            },
            getXYPos(elem) {
                let x = elem.offsetLeft
                let y = elem.offsetTop

                let offsetParent = elem.offsetParent
                while (offsetParent !== null) {
                    x = parseInt(x) + parseInt(offsetParent.offsetLeft)
                    y = parseInt(y) + parseInt(offsetParent.offsetTop)
                    offsetParent = offsetParent.offsetParent
                }

                return {x, y}
            }
        }
    }
</script>
